import { bindCsListFilters } from "./filters";
import { bindCsListFrame } from "./frame";
import { bindCsListGrid } from "./grid";
import { bindCsCellPopover } from "./cell_popover";
import { bindCsClientDrawer } from "./client_drawer";
import { bindCsTasksExport } from "./tasks_export";
import { bindCsClientPage } from "./client_page";
import { bindCsFocus } from "./focus";
import { bindFormControlsDismiss } from "./form_controls";
import { bindCsCampaignsView } from "./campaigns_view";
import { bindCsCampaignStars } from "./campaign_stars";
import { bindCsCampaignPreview } from "./campaign_preview_popover";

let bound = false;

// Document-level delegation, bound once: survives Turbo visits and restores without double-binding.
export function initCsList(): void {
  if (bound) return;
  bound = true;

  bindCsListFilters();
  bindCsListFrame();
  bindCsListGrid();
  bindCsCellPopover();
  bindCsClientDrawer();
  bindCsTasksExport();
  bindFormControlsDismiss();
  bindCsClientPage();
  bindCsFocus();
  bindCsCampaignsView();
  bindCsCampaignStars();
  bindCsCampaignPreview();
}
